import PropTypes from "prop-types";
import React, { useState } from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form, Spinner } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "@velzon/components/withRouter.js";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import postHub from "../../assets/images/PostHubb-logo.svg";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth.js";
import { forgetPassword } from "api/authentication/auth.js";
import { toast } from "react-toastify";

const ForgetPasswordPage = () => {
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    validateOnMount: true,
    // validateOnChange: true,

    initialValues: {
      email: ''
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Please enter a valid email address")
        .matches(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/, "Must be a valid email address")
        .required("Please Enter Your Email")
    }),
    onSubmit: async (values) => {
      setLoading(true)
      try {
        const payload = {
          email: values.email
        }
        const response = await forgetPassword(payload);

        toast.success(response.message)

        setTimeout(() => {
          navigate("/login")
        }, 1000)
      } catch(error) {
        toast.error(error?.response?.data?.message);
      }finally{
        setLoading(false)
      }
    }
  });

  document.title = "Reset Password";
  return (
    <ParticlesAuth>
      <div className="auth-page-content mt-lg-5">

        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                    <img src={postHub} alt="" height="100" />
                  </Link>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">

                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Forgot Password?</h5>

                    <lord-icon
                      src="https://cdn.lordicon.com/rhvddzym.json"
                      trigger="loop"
                      colors="primary:#0ab39c"
                      className="avatar-xl"
                      style={{ width: "120px", height: "120px" }}
                    >
                    </lord-icon>

                  </div>

                  <Alert className="border-0 alert-warning text-center mb-2 mx-2" role="alert">
                    Enter your email to receive the reset password link!
                  </Alert>
                  <div className="p-2">
                    {/* {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null} */}
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid"><div>{validation.errors.email}</div></FormFeedback>
                        ) : null}
                      </div>

                      <div className="text-center mt-4">
                        <button
                          disabled={loading || !validation.isValid}
                          className="btn btn-danger w-100"
                          type="submit"
                        >
                          {loading ? (
                            <>
                              <Spinner size="sm" className="me-2" />
                            </>
                          ) : (
                            "Send Reset Link"
                          )}
                        </button>

                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-0">Wait, I remember my password... <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> Click here </Link> </p>
              </div>

            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object
};

export default withRouter(ForgetPasswordPage);
